var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, OnInit } from '@angular/core';
import { HasSubscriptions } from '../has-subscriptions';
import { Router } from '@angular/router';
import { CommunicationService } from '../../services/communication.service';
import { PreferencesService } from '../../services/preferences.service';
import { SCREEN_SIZE, ListingCategory, MyRemaxModes } from '../../classes/enums';
import { UserService } from '../../services/user.service';
import { CredentialsService } from '../../services/credentials.service';
import { StaticPathPipe } from '../../shared/pipes/static-path.pipe';
import { Header } from '../../classes/interfaces';
import { debounceTime } from 'rxjs/operators';
var HeaderComponent = /** @class */ (function (_super) {
    __extends(HeaderComponent, _super);
    function HeaderComponent(communicationService, _preferencesService, userService, router, credentialService, staticPathPipe) {
        var _this = _super.call(this) || this;
        _this.communicationService = communicationService;
        _this._preferencesService = _preferencesService;
        _this.userService = userService;
        _this.router = router;
        _this.credentialService = credentialService;
        _this.staticPathPipe = staticPathPipe;
        _this.totalFavourites = 0;
        _this.showMyRemaxMenu = false;
        _this.isAuthenticated = false;
        _this.activeMyRemaxMode = MyRemaxModes.FAVOURITES; // Saved searches or Favourites Tab specifically for MyRemax Page
        _this.logos = (_a = {},
            _a[ListingCategory.RESIDENTIAL] = { n: 'REMAX_masterLogo@1x.svg', w: 'REMAX_masterLogo_white@1x.svg' },
            _a[ListingCategory.LUXURY] = { n: 'REMAX_Collection.svg', w: 'REMAX_Collection_white.svg' },
            _a[ListingCategory.COMMERCIAL] = { n: 'REMAX_Commercial.svg', w: 'REMAX_Commercial_white.svg' },
            _a);
        _this.faveIcons = (_b = {},
            _b[ListingCategory.RESIDENTIAL] = {
                on: { n: 'fave_icon_on_blue@2x.svg', w: 'fave_icon_on_white@2x.svg' },
                off: { n: 'fave_icon_off_blue@2x.svg', w: 'fave_icon_off_white@2x.svg' },
            },
            _b[ListingCategory.LUXURY] = {
                on: { n: 'fave_icon_on_blue@2x.svg', w: 'fave_icon_on_white@2x.svg' },
                off: { n: 'fave_icon_off_blue@2x.svg', w: 'fave_icon_off_white@2x.svg' }
            },
            _b[ListingCategory.COMMERCIAL] = {
                on: { n: 'fave_icon_on_gray@2x.svg', w: 'fave_icon_on_white@2x.svg' },
                off: { n: 'fave_icon_off_gray@2x.svg', w: 'fave_icon_off_white@2x.svg' }
            },
            _b);
        _this.accountIcons = (_c = {},
            _c[ListingCategory.RESIDENTIAL] = {
                on: { n: 'account_icon_on_blue@2x.svg', w: 'account_icon_on_white@2x.svg' },
                off: { n: 'account_icon_off_blue@2x.svg', w: 'account_icon_off_white@2x.svg' },
            },
            _c[ListingCategory.LUXURY] = {
                on: { n: 'account_icon_on_blue@2x.svg', w: 'account_icon_on_white@2x.svg' },
                off: { n: 'account_icon_off_blue@2x.svg', w: 'account_icon_off_white@2x.svg' },
            },
            _c[ListingCategory.COMMERCIAL] = {
                on: { n: 'account_icon_on_gray@2x.svg', w: 'account_icon_on_white@2x.svg' },
                off: { n: 'account_icon_off_gray@2x.svg', w: 'account_icon_off_white@2x.svg' },
            },
            _c);
        _this._showLeftNav = false;
        _this._showRightNav = false;
        _this.assetDir = '/assets/icons/nav-bar/';
        _this.header = {
            residential: {
                className: '',
                img: { src: '', height: 0, width: 0 },
                link: '/'
            },
            commercial: {
                className: '',
                img: { src: '', height: 0, width: 0 },
                link: '/commercial'
            },
            luxury: {
                className: '',
                img: { src: '', height: 0, width: 0 },
                link: '/luxury'
            }
        };
        // Enum
        _this.ListingCategory = ListingCategory;
        _this.SCREEN_SIZE = SCREEN_SIZE;
        return _this;
        var _a, _b, _c;
    }
    HeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this._preferencesService.favouriteListingsChanged.subscribe(function (value) { return _this.totalFavourites = value.length; }));
        this.addSub(this.communicationService.navigation.toggleNavs.subscribe(function (s) {
            _this._showLeftNav = s.left;
            _this._showRightNav = s.right;
        }));
        this.addSub(this.communicationService.screenSize.pipe(debounceTime(50)).subscribe(function (screenSize) {
            _this.screenSize = screenSize;
            _this.setState(_this.currentShownListingType);
        }));
        this.addSub(this.userService.currentUser.subscribe(function (currentUser) { return _this.currentUser = currentUser; }));
        this.addSub(this.credentialService.isLoggedIn.subscribe(function (isAuthenticated) { return _this.isAuthenticated = isAuthenticated; }));
        this.addSub(this.communicationService.activeMyRemaxMode.subscribe(function (mode) { return _this.activeMyRemaxMode = mode; }));
        this.addSub(this.communicationService.listings.currentShownListingType.subscribe(function (listingType) {
            _this.setState(listingType);
        }));
    };
    HeaderComponent.prototype.hideMyRemaxMenu = function (event) {
        if (this.showMyRemaxMenu && !this.myAccount.nativeElement.contains(event.toElement)) {
            this.showMyRemaxMenu = false;
        }
    };
    HeaderComponent.prototype.toggleLeftNav = function () {
        this.communicationService.navigation.toggleNavs.next({ left: !this._showLeftNav, right: false });
    };
    HeaderComponent.prototype.toggleRightNav = function (event) {
        event.stopPropagation();
        if (this.isMobile) {
            this.communicationService.navigation.toggleNavs.next({ left: false, right: !this._showRightNav });
        }
        else {
            // show my remax menu
            this.showMyRemaxMenu = !this.showMyRemaxMenu;
        }
    };
    Object.defineProperty(HeaderComponent.prototype, "isMobile", {
        get: function () {
            return this.screenSize < SCREEN_SIZE.DESKTOP_UP;
        },
        enumerable: true,
        configurable: true
    });
    HeaderComponent.prototype.updateCurrentListingType = function (newListingType) {
        this.communicationService.setCurrentListingType(newListingType, true);
        if (this.router.url.indexOf('/find-real-estate') < 0) {
            this.router.navigate(['/find-real-estate']);
        }
    };
    HeaderComponent.prototype.toHomePage = function (listingType) {
        this.communicationService.setCurrentListingType(listingType, true);
    };
    HeaderComponent.prototype.openRegisterLogin = function () {
        this.router.navigate(['/', { outlets: { popup: 'register-login' } }]);
    };
    HeaderComponent.prototype.toMyRemax = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._closeNavs();
                        return [4 /*yield*/, this.router.navigate(['/my-remax'])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    HeaderComponent.prototype.toFindListings = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if ($event)
                            $event.preventDefault();
                        this._closeNavs();
                        return [4 /*yield*/, this.router.navigate(['/find-real-estate'])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    HeaderComponent.prototype._closeNavs = function () {
        this.communicationService.navigation.toggleNavs.next({ left: false, right: false });
    };
    Object.defineProperty(HeaderComponent.prototype, "faveIcon", {
        get: function () {
            var isLuxury = this.currentShownListingType === ListingCategory.LUXURY;
            var icon = 'fave_icon_off@2x.svg';
            if (this.currentPage) {
                if (isLuxury) {
                    icon = this.faveIcons[this.currentShownListingType].off.w;
                }
                else {
                    icon = this.isMobile ? this.faveIcons[this.currentShownListingType].off.n : this.faveIcons[this.currentShownListingType].off.w;
                }
            }
            return this.staticPathPipe.transform(this.assetDir + icon);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HeaderComponent.prototype, "accountIcon", {
        get: function () {
            var isLuxury = this.currentShownListingType === ListingCategory.LUXURY;
            var icon = 'account_icon_off@2x.svg';
            if (this.currentPage) {
                var isAccount = this.currentPage.indexOf('/my-account') >= 0;
                var onOrOff = isAccount ? 'on' : 'off';
                if (isLuxury) {
                    icon = this.accountIcons[this.currentShownListingType][onOrOff].w;
                }
                else {
                    icon = this.isMobile ? this.accountIcons[this.currentShownListingType][onOrOff].n : this.accountIcons[this.currentShownListingType][onOrOff].w;
                }
            }
            return this.staticPathPipe.transform(this.assetDir + icon);
        },
        enumerable: true,
        configurable: true
    });
    HeaderComponent.prototype.setState = function (nextListingCategory) {
        this.header.residential.className = this.getLinkClass(ListingCategory.RESIDENTIAL, nextListingCategory);
        this.header.commercial.className = this.getLinkClass(ListingCategory.COMMERCIAL, nextListingCategory);
        this.header.luxury.className = this.getLinkClass(ListingCategory.LUXURY, nextListingCategory);
        this.header.residential.img.src = this.getLinkImg(ListingCategory.RESIDENTIAL, nextListingCategory);
        this.header.commercial.img.src = this.getLinkImg(ListingCategory.COMMERCIAL, nextListingCategory);
        this.header.luxury.img.src = this.getLinkImg(ListingCategory.LUXURY, nextListingCategory);
    };
    HeaderComponent.prototype.getLinkImg = function (listingCategory, nextListingCategory) {
        return this.getLinkImgSrc(listingCategory, nextListingCategory);
    };
    HeaderComponent.prototype.getLinkClass = function (listingCategory, nextListingCategory) {
        var type = ListingCategory[listingCategory];
        var active = ListingCategory[nextListingCategory];
        var shouldHide = nextListingCategory !== listingCategory ? 'hide-on-desktop-down' : '';
        return "link link-" + type + " active-" + active + " " + shouldHide;
    };
    HeaderComponent.prototype.getLinkImgSrc = function (listingCategory, nextListingCategory) {
        var isLuxury = nextListingCategory === ListingCategory.LUXURY;
        var img = isLuxury ? this.logos[listingCategory]['w'] : this.logos[listingCategory]['n'];
        return this.staticPathPipe.transform("/assets/REMAX_Logo/" + img);
    };
    Object.defineProperty(HeaderComponent.prototype, "isLuxury", {
        get: function () { return this.currentShownListingType === ListingCategory.LUXURY; },
        enumerable: true,
        configurable: true
    });
    ;
    return HeaderComponent;
}(HasSubscriptions));
export { HeaderComponent };
